import { render, staticRenderFns } from "./LDBTransaction.vue?vue&type=template&id=70da01ea"
import script from "./LDBTransaction.vue?vue&type=script&lang=js"
export * from "./LDBTransaction.vue?vue&type=script&lang=js"
import style0 from "./LDBTransaction.vue?vue&type=style&index=0&id=70da01ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports